var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.29618L11.5527 0.892769C11.1891 0.527683 10.6963 0.320801 10.1833 0.320801H1.93891C0.868471 0.324857 0 1.19701 0 2.27198V19.1471C0 20.2221 0.868471 21.0942 1.93891 21.0942H13.5724C14.6428 21.0942 15.5113 20.2221 15.5113 19.1471V5.6754C15.5113 5.16022 15.3053 4.66127 14.9417 4.29618ZM10.3409 2.43019L13.4148 5.5172H10.3409V2.43019ZM13.5724 19.1471H1.93891V2.27198H8.40195V6.49076C8.40195 7.03028 8.83416 7.46432 9.3714 7.46432H13.5724V19.1471Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00132 13.9794H6.52021V14.7805H3.68886V14.2013L5.16769 12.248H3.75356V11.4469H6.48632V12.0077L5.00132 13.9794Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11919 14.7805H7.07785V11.4469H8.11919V14.7805ZM7.01623 10.5874C7.01623 10.4395 7.06963 10.3183 7.17644 10.2238C7.28324 10.1294 7.42188 10.0821 7.59236 10.0821C7.76283 10.0821 7.90147 10.1294 8.00828 10.2238C8.11508 10.3183 8.16849 10.4395 8.16849 10.5874C8.16849 10.7353 8.11508 10.8564 8.00828 10.9509C7.90147 11.0454 7.76283 11.0926 7.59236 11.0926C7.42188 11.0926 7.28324 11.0454 7.17644 10.9509C7.06963 10.8564 7.01623 10.7353 7.01623 10.5874Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8563 13.1384C11.8563 13.656 11.7392 14.0698 11.5051 14.38C11.273 14.6881 10.9588 14.8421 10.5623 14.8421C10.2563 14.8421 10.0047 14.7302 9.80752 14.5063V16.0621H8.76926V11.4469H9.73974L9.77055 11.755C9.96978 11.5086 10.2317 11.3853 10.5562 11.3853C10.967 11.3853 11.2864 11.5373 11.5143 11.8413C11.7423 12.1432 11.8563 12.5592 11.8563 13.0891V13.1384ZM10.8181 13.0737C10.8181 12.4821 10.6455 12.1864 10.3005 12.1864C10.054 12.1864 9.88968 12.2747 9.80752 12.4513V13.7638C9.8979 13.9486 10.0643 14.0411 10.3066 14.0411C10.6373 14.0411 10.8078 13.7556 10.8181 13.1846V13.0737Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.320801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.dfc1ed6eaecfbcf8a52189e993e565f9.svg";
export { ForwardRef as ReactComponent };